// src/components/Reports/ReportsPage.jsx

import React, { useState, useEffect } from "react";
import OurLayouts from "../layout";
import DashboardOverview from "../Dashboard/DashboardOverview";
import { toast } from "react-toastify";
import axios from "axios";

import { Select, DatePicker } from "antd";
import "antd/dist/reset.css";

// ← Recharts
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";
import TotalPatients from "./TotalPatients";
import PatientsBySpeciality from "./PatientsBySpeciality";
import AppointmentDetails from "./AppointmentDetails";
import TopDiagnosis from "./TopDiagnosis";
import PaymentMode from "./PaymentMode";
import TopDrugs from "./TopDrugs";
import ServiceChart from "./ServiceChart";
import RevenueDetailsPie from "./RevenueDetailsPie";

const { Option } = Select;

const ReportsPage = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  // ─── your existing state ─────────────────────────────────────
  const [patientStats, setPatientStats] = useState({
    newPatients: 0,
    recurringPatients: 0,
    totalPatients: 0,
  });
  const [patientStats1, setPatientStats1] = useState({
    newPatients: 0,
    recurringPatients: 0,
    totalPatients: 0,
  });
  const [revenueData, setRevenueData] = useState(0);
  const [referralrevenueData, setReferralrevenueData] = useState(0);
  const [topConditions, setTopConditions] = useState([]);
  const [selectedRange, setSelectedRange] = useState("monthly");
  const [selectpaymenttype, setSelectpaymenttype] = useState("");
  // ─── new chart state ────────────────────────────────────────
  const [patientsData, setPatientsData] = useState([]);
  const [appointmentData, setAppointmentData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Completed");
  const [selectedDate, setSelectedDate] = useState(null);
  const [digitalPayment, setDigitalPayment] = useState(0);
  const [cashPayment, setCashPayment] = useState(0);
  const [diagnosisData, setDiagnosisData] = useState([]);
  const [specialityData, setSpecialityData] = useState([])
  const [activeTab, setActiveTab] = useState("Overview");
  const [serviceTypes, setServiceTypes] = useState(['CONSULTATION', 'PHARMACY', 'PATHOLOGY', 'RADIOLOGY'])
  const [selectedServiceType, setSelectedServiceType] = useState('PHARMACY')
  // at the top of ReportsPage()
  const [doctorList, setDoctorList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [drugData, setDrugData] = useState([])
  const [pharmacyData, setPharmacyData] = useState([]);
  const [pathologyData, setPathologyData] = useState([]);
  const [radiologyData, setRadiologyData] = useState([]);
  const [surgeryData, setSurgeryData] = useState([]);
  const tabs = [
    { name: "Overview", borderColor: "orange", count: 120, unit: "(summary)" },
    { name: "Total Patients", borderColor: "green", count: 560, unit: "(people)" },
    { name: "Appointment Details", borderColor: "blue", count: 75, unit: "(today)" },
    { name: "Top Diagnosis", borderColor: "purple", count: 5, unit: "(types)" },
    { name: "Revenue Details", borderColor: "red", count: 3, unit: "(types)" },
    { name: "Patients by Doctor", borderColor: "teal", count: 12, unit: "(fields)" },
    { name: "Top Drugs", borderColor: "indigo", count: 8, unit: "(medicines)" }, // ✅ new tab
    // { name: "PHARMACY", borderColor: "pink", count: 15, unit: "(items)" },
    { name: "Top Investigation", borderColor: "cyan", count: 20, unit: "(tests)" },
    // { name: "RADIOLOGY", borderColor: "lime", count: 10, unit: "(scans)" },
    // { name: "SURGERY", borderColor: "amber", count: 4, unit: "(operations)" }
  ];
  const [investigationType, setInvestigationType] = useState(['RADIOLOGY', 'PATHOLOGY'])
  const [selectedInvestigationType, setSelectedInvestigationType] = useState("RADIOLOGY")


  useEffect(() => {
    fetchDoctorList();
  }, []);

  const fetchDoctorList = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const { data } = await axios.get(
        `${API_URL}doctor/list?clinicId=${tenantId}`,
        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId, } }
      );

      setDoctorList(data);
    } catch (error) {
      console.error("Error fetching doctor list:", error);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Overview":
        return "";
      case "Total Patients":
        return <TotalPatients patientsData={patientsData} />;
      case "Appointment Details":
        return <AppointmentDetails appointmentData={appointmentData} />;
      case "Top Diagnosis":
        return <TopDiagnosis diagnosisData={diagnosisData} />;
      case "Revenue Details":
        return <PaymentMode
          digitalPayment={digitalPayment}
          cashPayment={cashPayment}
          selectpaymenttype={selectpaymenttype}
          setSelectpaymenttype={setSelectpaymenttype}
          serviceTypes={serviceTypes}
        />;
      case "Patients by Doctor":
        return <PatientsBySpeciality specialityData={specialityData}
          doctorList={doctorList}
          selectedDoctor={selectedDoctor}
          setSelectedDoctor={setSelectedDoctor} />;
      case "Top Drugs":
        return <TopDrugs
          chartData={drugData}
          serviceTypes={serviceTypes}
          selectedServiceType={selectedServiceType}
          setSelectedServiceType={setSelectedServiceType}
          showPatients={true}
        />;
      case "PHARMACY":
        return <ServiceChart title="PHARMACY" chartData={pharmacyData} />;
      case "Top Investigation":
        return <ServiceChart
          title="Top Investigation"
          chartData={pathologyData}
          showOptions={true}
          investigationType={investigationType}
          selectedInvestigationType={selectedInvestigationType}
          setSelectedInvestigationType={setSelectedInvestigationType}
          pathologyData={pathologyData}
          radiologyData={radiologyData}
          showPatients={true}


        />;
      case "RADIOLOGY":
        return <ServiceChart title="RADIOLOGY" chartData={radiologyData} />;
      // case "SURGERY":
      //   return <ServiceChart title="SURGERY" chartData={surgeryData} />;
      default:
        return "";
    }
  };

  const [specialityPatientsData, setSpecialityPatientsData] = useState([
    { label: "Cardiology", patients: 8200 },
    { label: "Dermatology", patients: 6700 },
    { label: "ENT", patients: 4800 },
    { label: "Orthopaedics", patients: 5600 },
    { label: "Neurology", patients: 7300 },
  ]);

  const fetchPaymentmode = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const params = new URLSearchParams({
        clinicId,
        timeFrame: selectedRange,
      });
      if (selectpaymenttype) {
        params.append("serviceType", selectpaymenttype);
      }

      const response = await fetch(
        `${API_URL}dashboard/paymode?${params.toString()}`,

        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
      );
      const data = await response.json();
      setDigitalPayment(data.digitalPayment || 0);
      setCashPayment(data.cashPayment || 0);
    } catch {
      toast.error("Failed to fetch referral revenue.");
    }
  };
  const totalPayment = cashPayment + digitalPayment;
  const digitalPct = totalPayment ? (digitalPayment / totalPayment) * 100 : 0;
  const cashPct = totalPayment ? (cashPayment / totalPayment) * 100 : 0;
  // const fetchreferral = async () => {
  //   const token = localStorage.getItem("auth_token");
  //   const tenantId = localStorage.getItem("tenantId");
  //   const clinicId = localStorage.getItem("clinicId");
  //   try {
  //     const response = await fetch(
  //       `${API_URL}dashboard/referral-revenue?clinicId=${clinicId}&timeFrame=${selectedRange}`,
  //       { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
  //     );
  //     const data = await response.json();
  //     setReferralrevenueData(data?.[clinicId] || 0);
  //   } catch {
  //     toast.error("Failed to fetch referral revenue.");
  //   }
  // };

  const fetchcondition = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const response = await fetch(
        `${API_URL}dashboard/conditions?clinicId=${clinicId}&timeFrame=${selectedRange}`,
        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
      );
      const data = await response.json();
      const top = data.topConditions || [];
      // map to { diagnosis, count }
      const formatted = top.map((item) => ({
        diagnosis: item._id && item._id.trim() ? item._id : "Other",
        count: item.totalCount,
      }));
      setDiagnosisData(formatted);
      // setTopConditions(validConditions);
    } catch {
      toast.error("Failed to fetch conditions.");
    }
  };

  const fetchAndSetChartData = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const response = await fetch(
        `${API_URL}dashboard/patients?clinicId=${clinicId}&timeFrame=${selectedRange}`,
        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
      );
      const data = await response.json();
      let chartData = [];

      if (selectedRange === "monthly") {
        chartData = (data.weeklyBreakdown || []).map((item) => ({
          label: item.week,
          new: item.newPatients,
          recurring: item.repeatPatients,
          followUp: item.totalPatients,
          male: item.male,
          female: item.female,
        }));
        setPatientStats({
          newPatients: data?.monthlySummary?.newPatients || 0,
          recurringPatients: data?.monthlySummary?.repeatPatients || 0,
          totalPatients: data?.monthlySummary?.totalPatients || 0,
        });
      } else if (selectedRange === "yearly") {
        chartData = (data.quarterlyBreakdown || []).map((item) => ({
          label: item.quarter,
          new: item.newPatients,
          recurring: item.repeatPatients,
          followUp: item.totalPatients,
          male: item.male,
          female: item.female,
        }));
        setPatientStats({
          newPatients: data?.yearlySummary?.newPatients || 0,
          recurringPatients: data?.yearlySummary?.repeatPatients || 0,
          totalPatients: data?.yearlySummary?.totalPatients || 0,
        });
      } else if (selectedRange === "weekly") {
        chartData = (data.dailyBreakdown || []).map((item) => ({
          label: item.day,
          new: item.newPatients,
          recurring: item.repeatPatients,
          followUp: item.totalPatients,
          male: item.male,
          female: item.female,
        }));
        setPatientStats({
          newPatients: data?.weeklySummary?.newPatients || 0,
          recurringPatients: data?.weeklySummary?.repeatPatients || 0,
          totalPatients: data?.weeklySummary?.totalPatients || 0,
        });
      } else if (selectedRange === "daily") {
        setPatientStats({
          newPatients: data?.summary?.newPatients || 0,
          recurringPatients: data?.summary?.repeatPatients || 0,
          totalPatients: data?.summary?.totalPatients || 0,
        });
        // Optionally you can create chartData for daily as well if data.dailyBreakdown exists
      }

      setPatientsData(chartData);
    } catch (error) {
      toast.error("Failed to fetch patient data.");
    }
  };


  const fetchAndSetData = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");

    try {
      const userIdParam = selectedDoctor ? `userId=${selectedDoctor}&` : "";
      const response = await fetch(
        `${API_URL}dashboard/patients?${userIdParam}timeFrame=${selectedRange}`,
        {
          headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
        }
      );

      const data = await response.json();

      let chartData = [];

      if (selectedRange === "monthly") {
        chartData = (data.weeklyBreakdown || []).map((item) => ({
          label: item.week,
          new: item.newPatients,
          recurring: item.repeatPatients,
          followUp: item.totalPatients,
        }));
        setPatientStats({
          newPatients: data?.monthlySummary?.newPatients || 0,
          recurringPatients: data?.monthlySummary?.repeatPatients || 0,
          totalPatients: data?.monthlySummary?.totalPatients || 0,
        });
      } else if (selectedRange === "yearly") {
        chartData = (data.quarterlyBreakdown || []).map((item) => ({
          label: item.quarter,
          new: item.newPatients,
          recurring: item.repeatPatients,
          followUp: item.totalPatients,
        }));
        setPatientStats({
          newPatients: data?.yearlySummary?.newPatients || 0,
          recurringPatients: data?.yearlySummary?.repeatPatients || 0,
          totalPatients: data?.yearlySummary?.totalPatients || 0,
        });
      } else if (selectedRange === "weekly") {
        chartData = (data.dailyBreakdown || []).map((item) => ({
          label: item.day,
          new: item.newPatients,
          recurring: item.repeatPatients,
          followUp: item.totalPatients,
        }));
        setPatientStats({
          newPatients: data?.weeklySummary?.newPatients || 0,
          recurringPatients: data?.weeklySummary?.repeatPatients || 0,
          totalPatients: data?.weeklySummary?.totalPatients || 0,
        });
      } else if (selectedRange === "daily") {
        // chartData = (data.dailyBreakdown || []).map((item) => ({
        //   label: item.day,
        //   new: item.newPatients,
        //   recurring: item.repeatPatients,
        //   followUp: item.totalPatients,
        // }));
        setPatientStats({
          newPatients: data?.summary?.newPatients || 0,
          recurringPatients: data?.summary?.repeatPatients || 0,
          totalPatients: data?.summary?.totalPatients || 0,
        });
      }

      setSpecialityData(chartData);
    } catch (error) {
      toast.error("Failed to fetch patient data.");
    }
  };

  // const fetchrevenue = async () => {
  //   const token = localStorage.getItem("auth_token");
  //   const tenantId = localStorage.getItem("tenantId");
  //   const clinicId = localStorage.getItem("clinicId");
  //   try {
  //     const response = await fetch(
  //       `${API_URL}dashboard/consultation-revenue?clinicId=${clinicId}&timeFrame=${selectedRange}`,
  //       { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
  //     );
  //     const data = await response.json();
  //     setRevenueData(data?.[clinicId] || 0);
  //   } catch {
  //     toast.error("Failed to fetch consultation revenue.");
  //   }
  // };
  const fetchDrugInfo = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const response = await fetch(
        `${API_URL}api/analytics/top-selling?clinicId=${clinicId}&serviceType=${selectedServiceType}&timeFrame=${selectedRange}`,
        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
      );
      const data = await response.json();
      const formatted = data.map((item) => ({
        label: item.itemName,
        quantity: item.totalQuantity,
        revenue: item.totalRevenue,
        patients: item?.patients
      }));

      setDrugData(formatted);
    } catch {
      toast.error("Failed to fetch consultation revenue.");
    }
  };
  const fetchServiceData = async (serviceType) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");

    try {
      const response = await fetch(
        `${API_URL}api/analytics/top-selling?clinicId=${clinicId}&serviceType=${serviceType}&timeFrame=${selectedRange}`,
        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
      );

      const data = await response.json();

      return data.map((item) => ({
        label: item.itemName,
        quantity: item.totalQuantity,
        revenue: item.totalRevenue,
        patients: item?.patients
      }));
    } catch (err) {
      toast.error(`Failed to fetch data for ${serviceType}.`);
      return [];
    }
  };
  useEffect(() => {
    const loadAllData = async () => {
      const [pharmacy, pathology, radiology, surgery] = await Promise.all([
        fetchServiceData("PHARMACY"),
        fetchServiceData("PATHOLOGY"),
        fetchServiceData("RADIOLOGY"),
        fetchServiceData("SURGERY"),
      ]);

      setPharmacyData(pharmacy);
      setPathologyData(pathology);
      setRadiologyData(radiology);
      setSurgeryData(surgery);
    };

    loadAllData();
  }, [selectedRange]);


  useEffect(() => {
    // fetchrevenue();
    // fetchreferral();
    fetchcondition();
    fetchAndSetChartData();
    fetchAppointmentData();
  }, [selectedRange, selectedDate]);
  useEffect(() => {
    fetchAndSetData();
  }, [selectedRange, selectedDoctor]);
  useEffect(() => {
    fetchPaymentmode();
  }, [selectedRange, selectpaymenttype]);
  useEffect(() => {
    fetchDrugInfo()
  }, [selectedServiceType])


  const fetchAppointmentData = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");

    // build URL with optional date/status
    let url = `${API_URL}dashboard/appointment-count?clinicId=${clinicId}&timeFrame=${selectedRange}`;
    // if (selectedDate)   url += `&date=${selectedDate}`;
    // if (selectedStatus) url += `&status=${selectedStatus}`;

    try {
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
      });
      const json = await res.json();

      let data = [];

      switch (selectedRange) {
        case "daily":
          data = [
            {
              date: selectedDate || new Date().toISOString().split("T")[0],
              total: json.summary?.appointments || 0,
            },
          ];
          break;

        case "weekly":
          data = (json.dailyBreakdown || []).map((item) => ({
            date: item.day,
            total: item.appointments,
          }));
          break;

        case "monthly":
          data = (json.weeklyBreakdown || []).map((item) => ({
            date: item.week,
            total: item.appointments,
          }));
          break;

        case "yearly":
          data = (json.quarterlyBreakdown || []).map((item) => ({
            date: item.quarter,
            total: item.appointments,
          }));
          break;
      }
      console.log(data, "cfgvkml");
      setAppointmentData(data);
    } catch {
      toast.error("Failed to fetch appointment data.");
    }
  };
  return (
    <OurLayouts>
      <div className="flex flex-col space-y-6">
        {/* ─── YOUR EXISTING OVERVIEW HEADER ────────────────────── */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-xl font-bold text-[#003A71]">Overview</h2>
          <div className="flex items-center gap-2">
            <select
              className="bg-white text-gray-600 px-8 py-3 rounded-md border border-gray-300 text-sm"
              value={selectedRange}
              onChange={(e) => setSelectedRange(e.target.value)}
            >
              <option value="daily">Today</option>
              <option value="weekly">Last 1 Week</option>
              <option value="monthly">Last 1 Month</option>
              <option value="yearly">Last 1 Year</option>
            </select>
          </div>
        </div>

        {/* ─── YOUR EXISTING DASHBOARD OVERVIEW CARDS ───────────── */}
        {/*<DashboardOverview
          overview={patientStats}
          revenue={revenueData}
          referralrevenueData={referralrevenueData}
          topConditions={diagnosisData}
        />*/}


        <div className="mt-0 bg-white rounded-xl shadow-sm">
          <div className="flex flex-wrap gap-2 p-2">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.name;
              const baseColor = tab.borderColor;


              return (
                <div
                  key={tab.name}
                  className={`w-[200px] p-3 text-center cursor-pointer rounded transition-all duration-200
        ${isActive
                      ? "bg-gradient-to-r from-[#004172] to-[#3cba84] text-white"
                      : `bg-${baseColor}-50 hover:bg-${baseColor}-100`
                    }`}
                  onClick={() => setActiveTab(tab.name)}
                >
                  <div className="text-lg">{tab.name}</div>
                </div>
              );
            })}

          </div>
        </div>

        <div>
          {renderContent()}
        </div>
        {activeTab == "Overview" && <div>

          {/* ─── NEW: TWO‐COLUMN CHART GRID ───────────────────────── */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 my-4">
            {/* Patients per Doctor */}
            <div className="bg-white rounded-xl shadow p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-md font-semibold text-[#003A71]">
                  Total Patients
                </h3>
              </div>

              <ResponsiveContainer width="100%" height={260}>
                <BarChart
                  data={patientsData}
                  margin={{ top: 10, right: 20, left: 0, bottom: 40 }}
                  barCategoryGap="15%"
                >
                  <CartesianGrid vertical={false} stroke="#f0f0f0" />
                  <XAxis
                    dataKey="label"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: "#666" }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: "#666" }}
                  />
                  <Tooltip
                    contentStyle={{ borderRadius: 8, fontSize: 12 }}
                    itemStyle={{ fontSize: 12 }}
                    formatter={(val) => `${val}`}
                  />
                  <Legend
                    verticalAlign="bottom"
                    height={40}
                    wrapperStyle={{
                      fontSize: 12,
                      paddingTop: 12,
                      display: "flex",
                      justifyContent: "center",
                      lineHeight: "20px",
                    }}
                  />
                  <Bar dataKey="recurring" name="Recurring Patient" fill="#003A71" radius={[4, 4, 0, 0]} />
                  <Bar dataKey="new" name="New Patient" fill="#FBB927" radius={[4, 4, 0, 0]} />
                  <Bar dataKey="followUp" name="Total Patient" fill="#00C48E" radius={[4, 4, 0, 0]} />
                  <Bar dataKey="male" name="Male Patient" fill="#FF6B6B" radius={[4, 4, 0, 0]} />
                  <Bar dataKey="female" name="Female Patient" fill="#6BCB77" radius={[4, 4, 0, 0]} />
                </BarChart>

              </ResponsiveContainer>
            </div>

            {/* Appointment Details */}
            <div className="bg-white rounded-xl shadow p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-md font-semibold text-[#003A71]">
                  Appointment Details
                </h3>
              </div>

              <ResponsiveContainer width="100%" height={260}>
                <AreaChart
                  data={appointmentData}
                  margin={{ top: 10, right: 20, left: 0, bottom: 5 }}
                >
                  <defs>
                    <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00C48E" stopOpacity={0.6} />
                      <stop offset="95%" stopColor="#00C48E" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid vertical={false} stroke="#f0f0f0" />
                  <XAxis dataKey="date" axisLine={false} tickLine={false} />
                  <YAxis axisLine={false} tickLine={false} />
                  <Tooltip formatter={(v) => [v, "Appointments"]} />
                  <Area
                    type="monotone"
                    dataKey="total"
                    stroke="#00C48E"
                    fill="url(#colorTotal)"
                    dot={{ r: 3 }}
                    activeDot={{ r: 5 }}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
          {/* ─── NEW: Revenue Details & TOP DIAGNOSIS ───────────────────── */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {/* Top Diagnosis (unchanged) */}
            <div className="bg-white rounded-xl shadow p-4">
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-md font-semibold text-[#003A71]">
                  Top Diagnosis
                </h3>
                {/* <DatePicker
                onChange={(_, dateString) => setSelectedDate(dateString)}
                placeholder="Select Date"
                size="small"
              /> */}
              </div>
              <ResponsiveContainer width="100%" height={200}>
                <AreaChart
                  data={diagnosisData}
                  margin={{ top: 8, right: 16, left: 0, bottom: 4 }}
                >
                  <defs>
                    <linearGradient
                      id="colorDiagnosis"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="0%" stopColor="#00B5E2" stopOpacity={0.6} />
                      <stop offset="100%" stopColor="#00B5E2" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid vertical={false} stroke="#f0f0f0" />
                  <XAxis
                    dataKey="diagnosis"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 11, fill: "#666" }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 11, fill: "#666" }}
                  />
                  <Tooltip
                    contentStyle={{ borderRadius: 6, fontSize: 11, padding: 6 }}
                    itemStyle={{ fontSize: 11 }}
                    formatter={(val) => [val, "Patients"]}
                  />
                  <Area
                    type="monotone"
                    dataKey="count"
                    stroke="#00B5E2"
                    fill="url(#colorDiagnosis)"
                    dot={{ r: 2, fill: "#00B5E2" }}
                    activeDot={{ r: 4, fill: "#00B5E2" }}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>

            {/* Revenue Details */}
            {/* <div className="bg-white rounded-xl shadow p-4">
              <div className="flex justify-between items-center mb-11">
                <h3 className="text-md font-semibold text-[#003A71]">
                  Revenue Details
                </h3>

                <select
                  className="bg-white text-gray-600 px-8 py-3 rounded-md border border-gray-300 text-sm"
                  value={selectpaymenttype}
                  onChange={(e) => setSelectpaymenttype(e.target.value)}
                >
                  <option value="">Select Service Type</option>
                  <option value="book_service">Book Service</option>
                  <option value="appointment">Appointment</option>
                </select>
               
              </div>

              <div className="flex w-full bg-gray-200 h-2 rounded overflow-hidden mb-3">
                <div
                  className="h-full"
                  style={{
                    width: `${digitalPct.toFixed(1)}%`,
                    backgroundColor: "#003A71",
                  }}
                />
                <div
                  className="h-full"
                  style={{
                    width: `${cashPct.toFixed(1)}%`,
                    backgroundColor: "#FBB927",
                  }}
                />
              </div>

              <div className="flex items-center mb-2">
                <span className="text-lg font-semibold">
                  ₹{digitalPayment.toLocaleString()}
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-gray-500 mb-4">
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-[#003A71] rounded-full mr-1" />
                  Digital Payment
                </div>
                <span>12/2/2025</span>
              </div>

              <div className="flex items-center mb-2">
                <span className="text-lg font-semibold">
                  ₹{cashPayment.toLocaleString()}
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-gray-500">
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-[#FBB927] rounded-full mr-1" />
                  Cash Payments
                </div>
                <span>12/2/2025</span>
              </div>
            </div> */}
            <div className="">
              <RevenueDetailsPie
                digitalPayment={digitalPayment}
                cashPayment={cashPayment}
                selectpaymenttype={selectpaymenttype}
                setSelectpaymenttype={setSelectpaymenttype}
                serviceTypes={serviceTypes}
              />
            </div>

            <div className="bg-white rounded-xl shadow p-6">
              <div className="flex justify-between items-center mb-20">
                <h3 className="text-md font-semibold text-[#003A71]">
                  Patients by Doctor
                </h3>

                <select
                  className="bg-white text-gray-600 px-4 py-2 rounded-md border border-gray-300 text-sm"
                  value={selectedDoctor}
                  onChange={(e) => setSelectedDoctor(e.target.value)}
                >
                  <option value="">All Doctors</option>
                  {doctorList.map((doc) => (
                    <option key={doc.doctorCode} value={doc.doctorCode}>
                      {doc.fullName}
                    </option>
                  ))}
                </select>
              </div>

              <ResponsiveContainer width="100%" height={260}>
                <BarChart
                  data={specialityData}
                  margin={{ top: 10, right: 20, left: 0, bottom: 40 }}
                  barCategoryGap="15%"
                >
                  <CartesianGrid vertical={false} stroke="#f0f0f0" />
                  <XAxis
                    dataKey="label"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: "#666" }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: "#666" }}
                  />
                  <Tooltip
                    contentStyle={{ borderRadius: 8, fontSize: 12 }}
                    itemStyle={{ fontSize: 12 }}
                    formatter={(val) => `${val}`}
                  />
                  <Legend
                    verticalAlign="bottom"
                    height={40}
                    wrapperStyle={{
                      fontSize: 12,
                      paddingTop: 12,
                      display: "flex",
                      justifyContent: "center",
                      lineHeight: "20px",
                    }}
                  />
                  <Bar
                    dataKey="recurring"
                    name="Recurring Patient"
                    fill="#ed7d31"
                    radius={[4, 4, 0, 0]}
                  />
                  <Bar
                    dataKey="new"
                    name="New Patient"
                    fill="#00b0f0"
                    radius={[4, 4, 0, 0]}
                  />
                  <Bar
                    dataKey="followUp"
                    name="Total Patient"
                    fill="#28a197"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
            {/* <div className="bg-white rounded-xl shadow p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-md font-semibold text-[#003A71]">
                  Top Drugs
                </h3>
              </div>

              <ResponsiveContainer width="100%" height={260}>
                <BarChart
                  data={drugData}
                  margin={{ top: 10, right: 20, left: 0, bottom: 40 }}
                  barCategoryGap="20%"
                >
                  <CartesianGrid vertical={false} stroke="#f0f0f0" />
                  <XAxis
                    dataKey="label"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: "#666" }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: "#666" }}
                  />
                  <Tooltip
                    contentStyle={{ borderRadius: 8, fontSize: 12 }}
                    itemStyle={{ fontSize: 12 }}
                    formatter={(val, name) =>
                      name === "Revenue" ? [`₹${val.toFixed(2)}`, name] : [val, name]
                    }
                  />
                  <Legend
                    verticalAlign="bottom"
                    height={40}
                    wrapperStyle={{
                      fontSize: 12,
                      paddingTop: 12,
                      display: "flex",
                      justifyContent: "center",
                      lineHeight: "20px",
                    }}
                  />
                  <Bar
                    dataKey="quantity"
                    name="Quantity Sold"
                    fill="#ed7d31"
                    radius={[4, 4, 0, 0]}
                  />
                  <Bar
                    dataKey="revenue"
                    name="Revenue"
                    fill="#00b0f0"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div> */}

            <div className="">
              <ServiceChart title="Top Drugs" chartData={pharmacyData} showPatients={false} showToggle={false} />
            </div>
            <div className="">
              <ServiceChart title="PATHOLOGY" chartData={pathologyData} />
            </div>
            <div className="">
              <ServiceChart title="RADIOLOGY" chartData={radiologyData} />
            </div>
            {/* <div className="bg-white rounded-xl shadow p-6">
              <ServiceChart title="SURGERY" chartData={surgeryData} />
            </div> */}
          </div>
        </div>}
      </div>
    </OurLayouts>
  );
};

export default ReportsPage;
